import {
  fetchProjectStart,
  fetchProjectSuccess,
  fetchProjectFailure,
  deleteProjectStart,
  deleteProjectSuccess,
  deleteProjectFailure,
  markCompletedProjectStart,
  markCompletedProjectSuccess,
  markCompletedProjectFailure,
  fetchProjectDetailsStart,
  fetchProjectDetailsSuccess,
  fetchProjectDetailsFailure,
  addProjectSuccess,
  addProjectStart,
  addProjectFailure,
  editProjectSuccess,
  editProjectStart,
  editProjectFailure,
} from "../../reducer/ManageProject/ManageProjectReducer";
import { axiosInstance } from "../../../components/common/interceptor";
import {
  COPY_PROJECT,
  DELETE_PROJECT,
  GET_PROJECT_DATA,
  MERGE_PROJECT,
} from "../../../components/common/api";

let isfetchProjectList = false;
let isdeleteProject = false;
let isprojectMarkasComplete = false;
let isGetProjectDetails = false;
let isAddProject = false;
let isEditProject = false;
let isCopyProject = false;
let isMergeProject = false;

// ................... Get project Management list .....................

export const fetchProjectList =
  (currentPage, searchTerm, itemsPerPage, sortField, sortOrder) =>
  async (dispatch) => {
    if (isfetchProjectList) return;
    isfetchProjectList = true;
    dispatch(fetchProjectStart());
    try {
      const params = {
        page: currentPage,
        size: itemsPerPage,
        sort: sortField || "updatedAt",
        // sort: sortField || "createdAt",
        order: sortOrder || "DESC",
      };
      if (searchTerm && searchTerm.trim() !== "") {
        params.search = searchTerm;
      }

      const response = await axiosInstance.get(`${GET_PROJECT_DATA}`, {
        params,
      });
      dispatch(
        fetchProjectSuccess({
          data: response?.data?.result,
          totalCount: response?.data?.result?.totalCount,
        })
      );
    } catch (error) {
      dispatch(
        fetchProjectFailure(
          error.response ? error.response.data : "An error occurred"
        )
      );
    } finally {
      isfetchProjectList = false;
    }
  };

// .............. Delete Project ...................

export const deleteProject = (projectId) => async (dispatch) => {
  if (isdeleteProject) return;
  isdeleteProject = true;
  dispatch(deleteProjectStart());
  try {
    const response = await axiosInstance.delete(
      `${DELETE_PROJECT}?project_id=${projectId}`
    );

    if (response.status !== 200) {
      throw new Error("Failed to block inspector.");
    }

    dispatch(deleteProjectSuccess(response?.data?.result));
  } catch (error) {
    console.error("Error blocking inspector:", error);
    dispatch(deleteProjectFailure(error.message));
  } finally {
    isdeleteProject = false;
  }
};

// .....................  Mark as Complete .....................

export const projectMarkasComplete = (projectId) => async (dispatch) => {
  if (isprojectMarkasComplete) return;
  isprojectMarkasComplete = true;
  dispatch(markCompletedProjectStart());
  try {
    const response = await axiosInstance.patch(
      `${DELETE_PROJECT}?project_id=${projectId}`
    );

    if (response.status !== 200) {
      throw new Error("Failed to mark project as complete.");
    }

    dispatch(markCompletedProjectSuccess(response.data.result));
  } catch (error) {
    console.error("Error marking project as complete:", error);
    dispatch(markCompletedProjectFailure(error.message));
  } finally {
    isprojectMarkasComplete = false;
  }
};

// .................. View Project Details ........................

export const GetProjectDetails = (projectId) => async (dispatch) => {
  if (isGetProjectDetails) return;
  isGetProjectDetails = true;
  dispatch(fetchProjectDetailsStart());
  try {
    const response = await axiosInstance.get(`${DELETE_PROJECT}`, {
      params: { project_id: projectId },
    });

    if (response.status !== 200) {
      throw new Error("Failed to fetch inspector details.");
    }
    dispatch(fetchProjectDetailsSuccess(response?.data?.result));
  } catch (error) {
    console.error("Error fetching details:", error);
    dispatch(fetchProjectDetailsFailure(error.message));
  } finally {
    isGetProjectDetails = false;
  }
};

// .................. Add Project ..........................

export const addProject = (projectData) => async (dispatch) => {
  if (isAddProject) return;
  isAddProject = true;
  console.log("formData", projectData);
  dispatch(addProjectStart());

  try {
    const response = await axiosInstance.post(
      `${DELETE_PROJECT}`,
      projectData,
      {}
    );
    dispatch(addProjectSuccess(response?.data));
    return response.data;
  } catch (error) {
    dispatch(
      addProjectFailure(
        error.response ? error.response.data : "An error occurred"
      )
    );
    throw error;
  } finally {
    isAddProject = false;
  }
};

// ................... Edit Project .....................

export const EditProject =
  (formData, isMultipart = false) =>
  async (dispatch) => {
    if (isEditProject) return;
    isEditProject = true;
    dispatch(editProjectStart());
    try {
      const headers = {
        "Content-Type": isMultipart
          ? "multipart/form-data"
          : "application/json",
      };
      const response = await axiosInstance.put(`${DELETE_PROJECT}`, formData, {
        headers,
      });

      if (response.status !== 200) {
        throw new Error("Failed to update project.");
      }
      console.log("response?.data?.result", response?.data?.result);
      dispatch(editProjectSuccess(response?.data?.result));
    } catch (error) {
      console.error("Error updating project:", error);
      dispatch(editProjectFailure(error.message));
    } finally {
      isEditProject = false;
    }
  };

export const copyProject = (projectId) => async () => {
  if (isCopyProject) return;
  isCopyProject = true;
  try {
    const response = await axiosInstance.post(`${COPY_PROJECT}`, {
      project_id: projectId,
    });
    return response?.data;
  } catch (error) {
    throw error;
  } finally {
    isCopyProject = false;
  }
};

export const mergeProject =
  (sourceProjectId, targetProjectId) => async () => {
    if (isMergeProject) return;
    isMergeProject = true;
    try {
      const response = await axiosInstance.post(`${MERGE_PROJECT}`, {
        source_project_id: sourceProjectId,
        target_project_id: targetProjectId,
      });
      return response?.data;
    } catch (error) {
      throw error;
    } finally {
      isMergeProject = false;
    }
  };
